package system.single

import com.github.quillraven.fleks.*
import com.github.quillraven.fleks.World.Companion.family
import component.*

class PlayerStateSystem : IteratingSystem(family { all(PlayerComponent, StateComponent) }) {
    override fun onTickEntity(entity: Entity) {
        val playerComp = entity[PlayerComponent]
        val stateComp = entity[StateComponent]
        val physComp = entity[PhysicComponent]

        val isGrounded = playerComp.playerMetadata.playerPhysicState.isGrounded

//        if (physComp.body.linearVelocityX > 0.01f) {
//            playerComp.direction = BodyDirection.RIGHT
//        } else if (physComp.body.linearVelocityX < -0.01f) {
//            playerComp.direction = BodyDirection.LEFT
//        }

        // falling
        if (!isGrounded && physComp.body.linearVelocityY > 0f) {
            stateComp.state = StateComponent.STATE_FALLING
        }

        // on wall
        val isOnWall = playerComp.playerMetadata.playerPhysicState.isOnWall
        if (isOnWall && physComp.body.linearVelocityY > 0f) {
            stateComp.state = StateComponent.STATE_ON_WALL
            physComp.body.linearVelocityY = 1.5f
        }

        if (isGrounded) {
            if (physComp.body.linearVelocityX == 0f) {
                // idle
                stateComp.state = StateComponent.STATE_NORMAL
            } else {
                // moving
                stateComp.state = StateComponent.STATE_MOVING
            }
        }
    }
}
